module.exports = __webpack_public_path__ + "./b96f17a8f37bcc262c75e6eb3f1f5beb-icon-service-marathon-small@2x.png";


//////////////////
// WEBPACK FOOTER
// ./plugins/services/src/img/icon-service-marathon-small@2x.png
// module id = 1085
// module chunks = 0